import React from 'react';
import { useTranslator } from '../I18n/useTranslator';
import { ToastContainer, cssTransition, toast, ToastContent } from 'react-toastify';
import ToastContext from './ToastContext';

const SlideFadeFromBottom = cssTransition({
  enter: 'slide-fade-from-bottom-fwd',
  exit: 'slide-fade-from-bottom-bck',
  collapse: false,
});

const SlideFadeFromTop = cssTransition({
  enter: 'slide-fade-from-top-fwd',
  exit: 'slide-fade-from-top-bck',
  collapse: false,
});

interface ToastProviderProps {
  children: React.ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const { t } = useTranslator();

  const toastError = (content?: ToastContent) => {
    toast.dismiss();

    toast.error(content ? content : <p className="mb-0">{t('error/message/toast/generic')}</p>, {
      position: 'top-center',
      autoClose: false,
      transition: SlideFadeFromTop,
      delay: 400,
    });
  };

  const toastSuccess = (content: ToastContent, autoClose?: number) => {
    toast.dismiss();

    toast.success(content, {
      position: 'bottom-center',
      closeButton: false,
      autoClose: autoClose ? autoClose : 2000,
      delay: 400,
      transition: SlideFadeFromBottom,
      pauseOnHover: false,
    });
  };

  return (
    <ToastContext.Provider value={{ toastError, toastSuccess, dismiss: toast.dismiss }}>
      <>
        <ToastContainer
          hideProgressBar
          closeOnClick={false}
          icon={false}
          newestOnTop={false}
          theme="colored"
        />
        {children}
      </>
    </ToastContext.Provider>
  );
};

export default ToastProvider;
